import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { firstValueFrom, tap } from 'rxjs';

import { ValidationService } from '../../utils/valibot/validation.service';
import {
  DetailedCountryConfiguration,
  DetailedCountryConfigurationSchema,
  FeatureFlagUpdate,
} from './model/feature-flag.model';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagClient {
  private static readonly urlPrefix = `country-configuration`;

  private readonly http = inject(HttpClient);
  private readonly logger = inject(NGXLogger);
  private readonly validationService = inject(ValidationService);

  getDetailedCountryConfigs(): Promise<DetailedCountryConfiguration> {
    const url = `${FeatureFlagClient.urlPrefix}`;
    this.logger.info(`#CDFTF0212 Loading detailed country configuration from ${url}`);
    return firstValueFrom(
      this.http.get(url).pipe(
        this.validationService.pipeResponse(DetailedCountryConfigurationSchema),
        tap({
          error: (error) => this.logger.error('#CDFTF0213 Unable to load detailed country configuration.', error),
        }),
      ),
    );
  }

  updateCountryConfigs(country: string, updates: FeatureFlagUpdate[]): Promise<DetailedCountryConfiguration> {
    const url = `${FeatureFlagClient.urlPrefix}/${country}`;
    this.logger.info(`#CDFTF0215 Update country configuration from ${url}`);
    return firstValueFrom(
      this.http.post(url, updates).pipe(
        this.validationService.pipeResponse(DetailedCountryConfigurationSchema),
        tap({
          error: (error) => this.logger.error('#CDFTF0216 Unable to update detailed country configuration.', error),
        }),
      ),
    );
  }
}
